<template>
    <div class="feed-back-c">
        <a :href="feedbackUrl" @click="handleClick" class="feed-back" target="_blank">
            <img class="fb-icon" src="../images/icon_Feedback_fd@2x.png" />
            <div class="tooltip-c">
                <div class="side-sohu-tooltip">举报/反馈</div>
                <div class="side-sohu-three"></div>
            </div>
        </a>
    </div>
</template>
<script>
import spmUtils from "@/utils/spm_utils"
import { env } from "@/env"

export default {
    name: "feedBack",
    computed: {
        articleUrl(){
            return window.location.origin + window.location.pathname
        },
        feedbackUrl(){
            const urlMap = {
                dev: `//beta.www.sohu.com/feedback?articleUrl=${this.articleUrl}`,
                test: `//beta.www.sohu.com/feedback?articleUrl=${this.articleUrl}`,
                pre: `//pre-www.sohu.com/feedback?articleUrl=${this.articleUrl}`,
                prod: `//www.sohu.com/feedback?articleUrl=${this.articleUrl}`
            }
            return urlMap[env]
        }
    },
    methods: {
        handleClick(){
            spmUtils.sendAction(8111)
        }
    },
};
</script>
<style lang="less" scoped>
.feed-back-c {
    width: 48px;

    .feed-back {
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;

        .fb-icon {
            width: 18px;
            height: 18px;
        }

        .tooltip-c {
            display: none;

            .side-sohu-tooltip {
                position: absolute;
                right: 58px;
                top: 10px;
                width: 78px;
                height: 32px;
                background: #333333;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 32px;
            }

            .side-sohu-three {
                border-bottom: 8px solid transparent;
                border-left: 4px solid #333;
                border-top: 8px solid transparent;
                height: 0;
                position: absolute;
                right: 54px;
                top: 18px;
                width: 0;
            }
        }
    }

    .feed-back:hover {
        .tooltip-c {
            display: block;
        }
    }
}</style>